import { createNamespacedHelpers, Module } from "vuex";
import { state } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";
import {
  RaterAccountsActions,
  RaterAccountsGetters,
  RaterAccountsMutations,
  RaterAccountsState
} from "./types";

const namespaced = true;
export const namespace = "raterAccounts";

export const {
  mapState: raterAccountsMapState,
  mapGetters: raterAccountsMapGetters,
  mapMutations: raterAccountsMapMutations,
  mapActions: raterAccountsMapActions
} = createNamespacedHelpers<
  RaterAccountsState,
  RaterAccountsGetters,
  RaterAccountsMutations,
  RaterAccountsActions
>(namespace);

export const raterAccounts: Module<RaterAccountsState, any> = {
  namespaced,
  state,
  getters,
  mutations,
  actions
};
